import { gql } from '@apollo/client';

export default gql`
  query inspectionDailyOverview($fromDate: ISO8601Date, $toDate: ISO8601Date) {
    inspectionDailyOverview(fromDate: $fromDate, toDate: $toDate) {
      overview {
        day
        pendingInspections
        completedInspections
        canceledInspections
      }
      period {
        from
        to
      }
    }
  }
`;
